import { render, staticRenderFns } from "./RecentClaim.vue?vue&type=template&id=69410046"
import script from "./RecentClaim.vue?vue&type=script&lang=js"
export * from "./RecentClaim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports